<template>
  <v-col cols="12">
    <subtitle-component>
      {{ socialMediaTitle }}
    </subtitle-component>
    <SocialMediaAuditData>
      <template v-slot="{ data }">
        <v-expansion-panels>
          <template v-for="item in data">
            <ExpansionPanel :isEmpty="isEmpty(item.audit)" :key="item.id">
              <template #header>
                <v-row no-gutters>
                  <ExpansionHeaderSocialMedia
                    :item="{ name: item.name, icon: item.icon }"
                  />
                  <template v-if="!isEmpty(item.audit)">
                    <v-col cols="3">
                      <Rate
                        :average="item.audit.score.last_value"
                        :info="item.info"
                      />
                      <slot name="rate"></slot>
                    </v-col>
                    <v-col cols="3">
                      <LastAudit :lastAudit="item.audit.score.diff" />
                    </v-col>
                  </template>
                  <template v-else-if="!item.isSet && isEmpty(item.audit)">
                    <v-col cols="6" class="d-flex align-center">
                      <v-btn color="primary" @click="goToProfile">
                        {{ $t("message.common.assignAccount") }}
                      </v-btn>
                    </v-col>
                  </template>
                  <template v-else>
                    <v-col cols="6" class="d-flex align-center">
                      <v-icon>mdi-database-search</v-icon>
                      <span class="ml-2">{{
                        $t("message.common.collectData")
                      }}</span>
                    </v-col>
                  </template>
                </v-row>
              </template>
              <template #content>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-tabs v-model="tab" centered slider-color="orange">
                      <v-tab>{{ $t("message.common.summary") }}</v-tab>
                      <v-tab>{{ $t("message.common.history") }}</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                      <v-tab-item>
                        <IndicatorsData :audit="item.audit" :name="item.name">
                          <template v-slot="{ formattedIndicators }">
                            <v-row no-gutters class="pa-4">
                              <v-col
                                cols="6"
                                v-for="indicator in formattedIndicators"
                                :key="indicator.id"
                                class="px-5"
                              >
                                <Indicator :indicator="indicator" />
                              </v-col>
                            </v-row>
                          </template>
                        </IndicatorsData>
                      </v-tab-item>
                      <v-tab-item>
                        <ChartData
                          :socialMediaItem="item"
                          :selectedChartItem="selectedChartItem"
                          :month="paginationMonth"
                        >
                          <template
                            v-slot="{
                              chartData,
                              items,
                              select,
                              currentMonth,
                              chartLoading
                            }"
                          >
                            <v-row no-gutters class="pa-4">
                              <v-col cols="4">
                                <v-select
                                  :items="items"
                                  :value="select"
                                  item-text="label"
                                  item-value="value"
                                  return-object
                                  @input="selectedChartItem = $event"
                                  :label="$t('message.common.pointer')"
                                ></v-select>
                              </v-col>
                              <v-col cols="12">
                                <div>
                                  <template
                                    v-if="
                                      chartData.data.length > 0 &&
                                        chartData.labels.length > 0
                                    "
                                  >
                                    <LineChart
                                      :height="400"
                                      :data="chartData.data"
                                      :labels="chartData.labels"
                                      :scale="select.scale"
                                      :key="select.value"
                                    />
                                  </template>
                                  <template v-else>
                                    <v-row no-gutters>
                                      <v-col
                                        cols="12"
                                        class="d-flex justify-center align-center flex-column"
                                        style="height: 400px;"
                                      >
                                        <v-icon
                                          x-large
                                          class="ma-2"
                                          color="primary"
                                        >
                                          mdi-database-search
                                        </v-icon>
                                        <h3>
                                          {{ $t("message.common.noData") }}
                                        </h3>
                                      </v-col>
                                    </v-row>
                                  </template>
                                  <SectionLoader :status="chartLoading" />
                                </div>
                                <ChartPagination
                                  @changeMonth="paginationMonth = $event"
                                  :currentMonth="currentMonth"
                                />
                              </v-col>
                            </v-row>
                          </template>
                        </ChartData>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-col>
                </v-row>
              </template>
            </ExpansionPanel>
          </template>
        </v-expansion-panels>
      </template>
    </SocialMediaAuditData>
  </v-col>
</template>

<script>
// Data
import SocialMediaAuditData from "@/components/data/Visibility/SocialMediaAudit.js";
import IndicatorsData from "@/components/data/Visibility/SocialMediaIndicators.js";
import ChartData from "@/components/data/Visibility/SocialMediaChart.js";

//UI
import ExpansionPanel from "@/components/ui/ExpansionPanel/ExpansionPanel.vue";
import ExpansionHeaderSocialMedia from "@/components/ui/ExpansionPanel/Header/SocialMedia.vue";
import BusinessAddress from "@/components/ui/ExpansionPanel/Header/BusinessAddress.vue";
import Indicator from "@/components/ui/ExpansionPanel/Content/Info/Indicator.vue";
import Rate from "@/components/ui/ExpansionPanel/Header/Rate.vue";
import LastAudit from "@/components/ui/ExpansionPanel/Header/LastAudit.vue";
import ChartPagination from "@/components/Chart/Pagination.vue";
import LineChart from "@/components/ui/ExpansionPanel/Content/History/chart.js";
import SectionLoader from "@/components/Loader/SectionLoader.vue";

import isEmpty from "lodash/isEmpty";
import SubtitleComponent from "@/components/ui/Subtitle/Subtitle.component.vue";

export default {
  name: "SocialMediaHOC",
  components: {
    ExpansionPanel,
    SocialMediaAuditData,
    ExpansionHeaderSocialMedia,
    ChartData,
    ChartPagination,
    Indicator,
    IndicatorsData,
    LastAudit,
    LineChart,
    Rate,
    SectionLoader,
    SubtitleComponent
  },
  data() {
    return {
      socialMediaTitle: this.$t("message.visibility.socialMedia.title"),
      tab: null,
      isEmpty: isEmpty,
      selectedChartItem: {},
      paginationMonth: {}
    };
  },

  methods: {
    goToProfile() {
      this.$router.push({ name: "profile-websites" });
    }
  }
};
</script>
